import { staticFile } from '@common/utils'
import Tooltip from '@components/common/tooltip'
import {
  COURSE_MODULES_IMAGE_PATH,
  MODULE_STATE,
} from '@lib/constants/course-modules'
import { ModuleStatType } from '@lib/types/course-modules'
import classNames from 'classnames'
import { Info } from 'react-feather'

const ModuleStat = ({
  title,
  stat,
  icon,
  moduleState,
  isGamificationPointsStat,
  tooltipMessage,
}: ModuleStatType) => (
  <div className="flex items-center space-x-2">
    <Tooltip
      content={<p className="text-center">{tooltipMessage}</p>}
      disabled={
        moduleState === MODULE_STATE.UPCOMING || isGamificationPointsStat
      }
      showOnHover
      placement="bottom-center"
    >
      <div
        className={classNames(
          'flex items-center justify-center relative rounded-full w-16 h-16',
          {
            'bg-green-50 bg-opacity-50': moduleState === MODULE_STATE.ONGOING,
            'bg-orange-200': moduleState !== MODULE_STATE.ONGOING,
            'cursor-pointer':
              !isGamificationPointsStat &&
              moduleState !== MODULE_STATE.UPCOMING,
          }
        )}
      >
        <img
          src={staticFile(
            `${COURSE_MODULES_IMAGE_PATH}course-overview-card/${icon}.svg`
          )}
        />
        {moduleState === MODULE_STATE.COMPLETED &&
          !isGamificationPointsStat && (
            <img
              src={staticFile(
                `${COURSE_MODULES_IMAGE_PATH}module-card/${
                  stat.completed === stat.total ? 'check-mark' : 'alert'
                }.png`
              )}
              className="w-5 absolute top-0 right-0"
            />
          )}
      </div>
    </Tooltip>
    <div className="flex flex-col space-y-2">
      <p>{title}</p>
      {isGamificationPointsStat && moduleState !== MODULE_STATE.UPCOMING ? (
        <div className="flex space-x-1 items-center">
          <p className="font-600 text-lg">{stat.completed}</p>
          <Tooltip
            content={`${stat.completed !== 0 ? 'Yay!' : ''} You have earned ${
              stat.completed
            } points in this module. Complete everything on time and continue attending more classes to earn more points.`}
            showOnHover
          >
            <Info className="text-grey-700 cursor-pointer" size={18} />
          </Tooltip>
        </div>
      ) : (
        <div className="font-600 text-lg">
          {moduleState !== MODULE_STATE.UPCOMING && (
            <span>{stat.completed}/</span>
          )}
          <span>{stat.total}</span>
        </div>
      )}
    </div>
  </div>
)

export default ModuleStat
